import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import { FieldInputProps } from "react-final-form";
import { NavLink } from "react-router-dom";
import "./Url.scss";

interface UrlProps {
    isReadOnly: boolean;
    url: string;
    text: string;
    isOpenLinkButtonShown: boolean;
    id: string;
    input?: FieldInputProps<any>;
    target?: string;
}

export const Url = ({
    isReadOnly,
    url,
    text,
    isOpenLinkButtonShown,
    id,
    input,
    target,
}: UrlProps) => {
    return (
        <>
            {isReadOnly ? (
                target ? (
                    <a rel="noreferrer" href={url} className="urlLinkReadonly" target={target}>
                        {text}
                    </a>
                ) : (
                    <NavLink to={url} className="urlLinkReadonly" rel="noopener noreferrer">
                        {text}
                    </NavLink>
                )
            ) : (
                <input
                    id={id}
                    {...input}
                    aria-label={`${id}`}
                    type="Url"
                    className="input__field"
                />
            )}
            {isOpenLinkButtonShown && (
                <Button
                    external
                    href={url}
                    title=""
                    icon={IconCollection.openInNew}
                    variation="clear"
                    className={`openLinkButton${isReadOnly ? " readOnlyLinkButton" : ""}`}
                    target={target}
                />
            )}
        </>
    );
};
